const deleteExecutorDenied = {
    title: 'Ошибка удаления',
    description: 'Нельзя удалить исполнителя, по которому проводились платежи',
    mode: 'denied',
} as const;

export default deleteExecutorDenied;
